import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box, Row } from '~/commonComponents';

interface IReferralSummaryProps {
  totalReferrals: number;
  totalEarned: number;
  style?: React.CSSProperties;
}

export const ReferralSummary = ({ totalReferrals, totalEarned, style }: IReferralSummaryProps) => {
  return (
    <Row
      width={'532px'}
      backgroundColor={colors.neutral[50]}
      borderRadius={7}
      padding={10}
      alignItems="center"
      justifyContent="center"
      style={style}
    >
      <Typography as="span" size="heading_3" bold color={colors.primary[500]} style={{ marginRight: 9 }}>
        {totalReferrals}
      </Typography>
      <Typography as="span"> Total Referrals </Typography>

      <Box
        width={2}
        height="100%"
        backgroundColor={colors.neutral[100]}
        marginLeft={24}
        marginRight={28}
      />

      <Typography as="span" size="heading_3" bold color={colors.success[400]} style={{ marginRight: 9 }}>
        ${totalEarned}
      </Typography>
      <Typography as="span">Earned</Typography>
    </Row>
  );
};
